import { createAction, props } from '@ngrx/store';

export const applicationVersionChanged = createAction(
   '[App] Application Version Changed',
   props<{ oldVersion: string | null; newVersion: string }>()
);

export const applicationVersionChangeAcknowledged = createAction('[App] Application Version Change Acknowledged');

export const applicationVersionChangeAcknowledgementSkipped = createAction(
   '[App] Application Version Change Acknowledgement Skipped'
);
